import React, {useState, useEffect} from "react";
import {Button, Col, Form, Row, Select, Space} from "antd";
import {EditOutlined, CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {useStore} from "hooks/useStore";
import {providerCompanies} from "constants/constants";
import CourierVionTransitionModal from "./CourierVionTransitionModal";

const CourierSummaryProviderCompany = ({
    providerCompany: initialProviderCompany,
    selectedProviderCompany,
    vionTransitionDate,
    courierId,
    onProviderCompanyUpdated
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [form] = Form.useForm();
    const [transitionModalOpen, setTransitionModalOpen] = useState(false);
    const [pendingProviderCompany, setPendingProviderCompany] = useState(undefined);
    const stores = useStore();

    const resolvedValue =
        selectedProviderCompany !== undefined ? selectedProviderCompany : initialProviderCompany;

    useEffect(() => {
        form.setFieldsValue({
            providerCompany: resolvedValue ?? undefined
        });
    }, [resolvedValue]);

    const displayLabel = () => {
        const item = providerCompanies.find(x => x.value === resolvedValue);
        return item?.name ?? "-";
    };

    const handleEdit = () => {
        form.setFieldsValue({providerCompany: resolvedValue ?? undefined});
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        form.resetFields();
    };

    const handleSubmit = values => {
        // Seçim yoksa istek atma (backend enum değeri bekliyor)
        if (!values.providerCompany) {
            setIsEditing(false);
            return;
        }
        // Tüm sağlayıcılar için geçiş tarihini almak üzere modal aç;
        // kayıt (check + update) modal içinde yapılır
        setPendingProviderCompany(values.providerCompany);
        setTransitionModalOpen(true);
    };

    // Modal içindeki provider-company update başarılı olunca: düzenlemeyi kapat + kuryeyi yenile
    const handleModalSuccess = () => {
        setIsEditing(false);
        setTransitionModalOpen(false);
        onProviderCompanyUpdated?.();
    };

    return (
        <Form
            form={form}
            onFinish={handleSubmit}
            initialValues={{providerCompany: resolvedValue ?? undefined}}
        >
            <Row gutter={[8, 8]} align="middle">
                <Col flex="auto">
                    {isEditing ? (
                        <Form.Item name="providerCompany" style={{marginBottom: 0}}>
                            <Select
                                allowClear
                                placeholder="Seçiniz"
                                style={{width: "100%", maxWidth: 220}}
                            >
                                {providerCompanies.map(option => (
                                    <Select.Option key={option.value} value={option.value}>
                                        {option.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    ) : (
                        <div style={{padding: "5px 0"}}>{displayLabel()}</div>
                    )}
                </Col>
                <Col>
                    {stores.meStore.checkRole("editProviderCompany") &&
                        (isEditing ? (
                            <Space>
                                <Button type="text" icon={<CheckOutlined />} htmlType="submit" />
                                <Button
                                    type="text"
                                    icon={<CloseOutlined />}
                                    onClick={handleCancel}
                                />
                            </Space>
                        ) : (
                            <Button type="text" icon={<EditOutlined />} onClick={handleEdit} />
                        ))}
                </Col>
            </Row>
            <CourierVionTransitionModal
                open={transitionModalOpen}
                onCancel={() => setTransitionModalOpen(false)}
                courierId={courierId}
                providerCompany={pendingProviderCompany}
                providerCompanyName={
                    providerCompanies.find(x => x.value === pendingProviderCompany)?.name
                }
                onSuccess={handleModalSuccess}
                initialDate={vionTransitionDate}
            />
        </Form>
    );
};

export default CourierSummaryProviderCompany;
